import { createApiHook } from '../hooks';
import { notificationsApiFactory } from './notificationsApiFactory';

export const useNotificationsApi = createApiHook(notificationsApiFactory);
